import {connect} from 'react-redux'
import DeliveryMap from "../../Components/Map/DeliveryMap/DeliveryMap";
import * as deliveryGroupsActions from "../actions/deliveryGroupsActions";
import * as activeMessengersActions from "../actions/activeMessengersActions";
import * as ordersActions from "../actions/ordersActions";

const mapStateToProps = (store) => {
    return {
        proposedDeliveryGroups: store.deliveryGroupsReducer.proposedDeliveryGroups,
        assignedDeliveryGroups: store.deliveryGroupsReducer.assignedDeliveryGroups,
        lockedDeliveryGroups: store.deliveryGroupsReducer.lockedDeliveryGroups,
        sentLockedDeliveryGroups: store.deliveryGroupsReducer.sentLockedDeliveryGroups,
        evaluatingProposedDeliveryGroups: store.deliveryGroupsReducer.evaluatingProposedDeliveryGroups,
        sla: store.businessReducer.business.sla,
        readySla: store.businessReducer.business.readySla,
        activeMessengers: store.activeMessengersReducer.activeMessengers,
        deliveryGroupsError: store.deliveryGroupsReducer.evaluateDeliveryGroupsError,
        isAutopilot: store.businessReducer.business.isAutopilot,
        placesOfDeparture: store.businessReducer.business.placesOfDeparture,
        polygonToShow: store.businessReducer.business.polygonToShow
    };
};

const mapDispatchToProps = {
    fetchDeliveryGroups: deliveryGroupsActions.fetchAssignedDeliveryGroupsAction,
    fetchLockedDeliveryGroups: deliveryGroupsActions.fetchLockedDeliveryGroupsAction,
    fetchActiveMessengersLocations: activeMessengersActions.fetchActiveMessengersLocationsAction,
    fetchOrders: ordersActions.fetchOrdersAction
};

const DeliveryMapContainer = connect(mapStateToProps, mapDispatchToProps)(DeliveryMap);

export default DeliveryMapContainer;